import setFadeUpTimeline from './fade-up';
import setCounterTimeline from './numbers-counter';
import setDecoration from './decorations';
import setHeroDecoration from './hero-decorations';
import setLottieIcons from './lottie-icons';

export default function setupAnimation(className, type) {
  window.scrollTo(0, 0);

  if (type === 'fadeup') setFadeUpTimeline(className);
  if (type === 'counter') setCounterTimeline(className);
  if (type === 'decoration') setDecoration(className);
  if (type === 'hero-decoration') setHeroDecoration(className);
  if (type === 'lottie-icons') setLottieIcons(className);
}
